<template>
  <div class="capsule-toy-land">
    <div class="background">
      <!-- Header with coin count -->
      <div class="header">
        <div class="coin-container">
          <div class="coin-icon"></div>
          <div class="coin-count">500</div>
        </div>
        <div class="my-rewards">
          <div class="rewards-icon"></div>
          <div class="rewards-text">我的獎品</div>
        </div>
      </div>

      <!-- Main content -->
      <div class="main-content">
        <div class="white-card">
          <h1 class="title">扭蛋樂園</h1>
          <div class="description">
            <p>歡迎來到MSU扭蛋樂園！</p>
            <p>
              你知道嗎？只要你認真看完一本繪本或一支英文影片，就能獲得一個綠色勾勾
              ✅，每個綠勾勾都會變成一枚【扭蛋幣】！
            </p>
            <p>
              在這裡，蒐集滿100枚扭蛋幣，就可以轉一次扭蛋，有機會抽中超酷的不鏽鋼保溫瓶、可愛貼紙包，還有超商禮券等好禮等你拿～
            </p>
            <p>
              MSU每月會公布中獎名單，獎品會送到你班上，請老師發給你喔！
              快開始閱讀和觀看影片，努力集扭蛋幣，把獎品通通帶回家吧！
            </p>
          </div>
          <button class="play-button">PLAY</button>
        </div>
      </div>

      <!-- Prize showcase section -->
      <div class="prize-section">
        <div class="section-title">
          <div class="section-title-bg">
            <span>獎品介紹</span>
          </div>
        </div>

        <div class="prize-cards">
          <div class="prize-card" v-for="(prize, index) in prizes" :key="index">
            <div
              class="prize-image"
              :style="{ backgroundImage: `url(${prize.image})` }"
            ></div>
            <div class="prize-name" v-html="prize.name"></div>
          </div>
        </div>
      </div>

      <!-- Footer decoration -->
      <div class="footer-decoration"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapsuleToyLand",
  data() {
    return {
      prizes: [
        {
          name: "mangoSTEEMS Polo衫<br>(示意圖)",
          image: "/images/prizes/polo-shirt.png",
        },
        {
          name: "馬卡龍噴霧原子筆",
          image: "/images/prizes/macaroon-pen.png",
        },
        {
          name: "mangoSTEEMS<br>不鏽鋼保溫瓶",
          image: "/images/prizes/thermos.png",
        },
        {
          name: "百元禮券",
          image: "/images/prizes/gift-card.png",
        },
        {
          name: "MSU便利貼",
          image: "/images/prizes/sticky-notes.png",
        },
        {
          name: "MSU 限定托特包",
          image: "/images/prizes/tote-bag.png",
        },
        {
          name: "MSU 造型角色貼紙包",
          image: "/images/prizes/sticker-pack.png",
        },
        {
          name: "MSU索引貼",
          image: "/images/prizes/index-stickers.png",
        },
        {
          name: "MSU 角色貼紙 (圓形)",
          image: "/images/prizes/circle-stickers.png",
        },
        {
          name: "扭蛋幣",
          image: "/images/prizes/capsule-coin.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.capsule-toy-land {
  width: 100%;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
  color: #583110;
}

.background {
  background-color: #d7b19b;
  background-image: url("/images/background-pattern.png");
  background-size: cover;
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

/* Header styling */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.coin-container {
  display: flex;
  align-items: center;
}

.coin-icon {
  width: 30px;
  height: 30px;
  background-image: url("/images/coin-icon.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.coin-count {
  font-family: "ADLaM Display", sans-serif;
  font-size: 20px;
  color: #583110;
}

.my-rewards {
  display: flex;
  align-items: center;
}

.rewards-icon {
  width: 28px;
  height: 28px;
  background-image: url("/images/rewards-icon.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.rewards-text {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.8px;
}

/* Main content styling */
.main-content {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 0 20px;
}

.white-card {
  background-color: white;
  border-radius: 16px;
  padding: 30px;
  width: 100%;
  max-width: 785px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #583110;
}

.description {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 30px;
}

.description p {
  margin-bottom: 15px;
}

.description p:first-child {
  font-weight: 700;
}

.play-button {
  background-color: #7a4210;
  color: #f5f5f5;
  font-size: 20px;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  padding: 8px 30px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: block;
  margin: 0 auto;
}

.play-button:hover {
  background-color: #915109;
}

/* Prize section styling */
.prize-section {
  margin-top: 40px;
}

.section-title {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.section-title-bg {
  background-image: url("/images/section-title-bg.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 15px 40px;
  text-align: center;
}

.section-title-bg span {
  color: #f5f5f5;
  font-size: 20px;
  font-weight: 700;
}

.prize-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.prize-card {
  width: 250px;
  background-color: white;
  border-radius: 16px;
  padding: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.prize-image {
  width: 150px;
  height: 168px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 35px;
}

.prize-name {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

/* Footer decoration */
.footer-decoration {
  height: 100px;
  margin-top: 20px;
  background-image: url("/images/footer-decoration.png");
  background-size: contain;
  background-repeat: repeat-x;
  background-position: bottom;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .prize-cards {
    gap: 10px;
  }

  .prize-card {
    width: 45%;
    padding: 20px;
  }

  .prize-image {
    width: 100px;
    height: 120px;
    margin-bottom: 20px;
  }

  .prize-name {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .prize-card {
    width: 100%;
  }

  .white-card {
    padding: 20px;
  }

  .description {
    font-size: 14px;
  }
}
</style>
